import { render } from "./Footer.vue?vue&type=template&id=77626650&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=77626650&lang=scss&scoped=true"

import exportComponent from "/Users/benjamin_nalo/Ben/portfolio-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77626650"]])

export default __exports__